import { OidBase } from './oid-base.js'

export class OidWeb extends OidBase {
}